<!-- Groomed: three short blue strokes, matching the removable status plate. -->
<i class="cord" aria-hidden="true"></i>

<style>
  .cord {
    position: relative;
    display: inline-block;
    flex: none;
    width: 10px;
    height: 8px;
    border-top: 1.5px solid var(--blue);
    border-bottom: 1.5px solid var(--blue);
    vertical-align: middle;
  }
  .cord::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 1.75px;
    border-top: 1.5px solid var(--blue);
  }
</style>
